import { useEffect, useState } from 'react'

type WindowDimensions = {
  width: number
  height: number
}

export function useWindowDimensions(): WindowDimensions {
  const getSize = () => ({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  const [dimensions, setDimensions] = useState(getSize)

  useEffect(() => {
    const handleResize = () => setDimensions(getSize())

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return dimensions
}
